export default __webpack_public_path__ + "static/media/summoners_mobile.4ce05b3e.png";